export default class LocalStorageHelper {
  static setData(key, value) {
    if (typeof Storage !== 'undefined') {
      localStorage.setItem('spruceFlow.' + key, value);
    }
  }

  static getData(key) {
    return localStorage.getItem('spruceFlow.' + key);
  }

  static clearAllData() {
    Object.keys(localStorage).forEach((key) => {
      if (key !== 'fetchTraceId' && key !== 'enablePolly' && key !== 'pollyjs') {
        return localStorage.removeItem(key);
      }
    });
  }
}
